/* src/app/ol-map/ol-map.component.css */
:host ::ng-deep .toolsPanel .ui-fieldset-legend {
  display: none;
}
:host ::ng-deep div.ol-zoom-extent.ol-unselectable.ol-control button {
  display: none;
}
:host ::ng-deep div.ol-zoom.ol-unselectable.ol-control {
  position: absolute !important;
  top: 10px;
  right: 5px;
  z-index: 999;
  padding: 0px;
}
:host ::ng-deep .ol-zoom {
  left: auto;
  background: transparent;
  height: 70px;
  margin: 0px;
}
:host ::ng-deep .ol-zoom-in:hover,
:host ::ng-deep .ol-zoom-out:hover {
  background-color: gray;
  color: white;
  cursor: pointer;
}
:host ::ng-deep .ol-zoom-in:focus,
:host ::ng-deep .ol-zoom-out:focus {
  background-color: gray;
  color: white;
  cursor: pointer;
}
:host ::ng-deep .ol-zoom-in {
  color: black;
  background-color: white;
  width: 33px;
  height: 33px;
  margin: 0px;
  margin-bottom: 4px;
  border: 0px;
  border-radius: 0px;
  color: gray;
}
:host ::ng-deep .ol-zoom-out {
  color: black;
  background-color: white;
  width: 33px;
  height: 33px;
  border: 0px;
  border-radius: 0px;
  margin: 0px;
  color: gray;
}
:host ::ng-deep .toolContainer {
}
.toolSelectHolder {
  top: 72px;
  right: -7px;
  position: absolute;
  width: 109px;
  height: 46px;
  padding: 0px;
}
.toolSelectHolder .t1.active_false {
  display: block;
  background: white;
  margin: 1px;
  margin-right: 2px;
  width: 33px;
  height: 33px;
  background-image: url(/assets/img/area-measure-disabled.png);
  background-position: center;
  background-repeat: no-repeat;
  opacity: 1;
  cursor: pointer;
  border-radius: 0px;
  float: right;
}
.toolSelectHolder .t1.active_true {
  display: block;
  background: white;
  margin: 1px;
  margin-right: 2px;
  width: 33px;
  height: 33px;
  background-image: url(/assets/img/area-measure.png);
  background-position: center;
  background-repeat: no-repeat;
  opacity: 1;
  cursor: pointer;
  border-radius: 0px;
  float: right;
}
.toolSelectHolder .t2.active_true {
  display: block;
  background: white;
  margin: 1px;
  margin-top: -10px;
  margin-right: 2px;
  width: 33px;
  height: 33px;
  background-image: url(/assets/img/length-measure.png);
  background-position: center;
  background-repeat: no-repeat;
  opacity: 1;
  cursor: pointer;
  border-radius: 0px;
  float: right;
}
.toolSelectHolder .t2.active_false {
  display: block;
  background: white;
  margin: 1px;
  margin-top: -10px;
  margin-right: 2px;
  width: 33px;
  height: 33px;
  background-image: url(/assets/img/length-measure-disabled.png);
  background-position: center;
  background-repeat: no-repeat;
  opacity: 1;
  cursor: pointer;
  border-radius: 0px;
  float: right;
}
.toolSelectHolder .t3.active_true {
  display: block;
  background: white;
  margin: 1px;
  margin-top: -21px;
  margin-right: 2px;
  width: 33px;
  height: 33px;
  background-image: url(/assets/img/pan.png);
  background-position: center;
  background-repeat: no-repeat;
  opacity: 1;
  cursor: pointer;
  border-radius: 0px;
  float: right;
}
.toolSelectHolder .t3.active_false {
  display: block;
  background: white;
  margin: 1px;
  margin-top: -21px;
  margin-right: 2px;
  width: 33px;
  height: 33px;
  background-image: url(/assets/img/pan-disabled.png);
  background-position: center;
  background-repeat: no-repeat;
  opacity: 1;
  cursor: pointer;
  border-radius: 0px;
  float: right;
}
:host ::ng-deep .vectorMap {
  height: 70px;
  width: 70px;
  background-repeat: no-repeat;
  background-image: url(/assets/img/vectorMap.png);
  background-position: inherit;
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 45px;
}
:host ::ng-deep .hybridMap {
  height: 70px;
  width: 70px;
  background-repeat: no-repeat;
  background-image: url(/assets/img/hybridMap.png);
  background-position: inherit;
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 45px;
}
:host ::ng-deep .messureValueContainer {
  position: absolute;
  bottom: 10px;
  right: 10px;
  font-size: 16px;
  background-color: rgba(255, 255, 255, 0.7);
  min-width: 150px;
  padding-left: 10px;
  padding-right: 10px;
  text-align: center;
  color: black;
}
/*# sourceMappingURL=ol-map.component.css.map */
